const LogIcon = () => {
  return (
    <svg
      id="Group_9448"
      data-name="Group 9448"
      xmlns="http://www.w3.org/2000/svg"
      width="24.428"
      height="24.428"
      viewBox="0 0 24.428 24.428"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5539"
            data-name="Rectangle 5539"
            width="24.428"
            height="24.428"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9447" data-name="Group 9447" clipPath="url(#clip-path)">
        <path
          id="Path_12176"
          data-name="Path 12176"
          d="M0,3.135v5.82H9.033V4.623l9.8,7.623-9.8,8.068v-4.9H0v5.883a3.135,3.135,0,0,0,3.135,3.135H21.293a3.135,3.135,0,0,0,3.135-3.135V3.135A3.135,3.135,0,0,0,21.293,0H3.135A3.135,3.135,0,0,0,0,3.135"
          transform="translate(0 0)"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default LogIcon
